import React from "react";
import { UseFormRegister } from "react-hook-form";
import { ReconciliationFormData } from "../ReconciliationModal";

export interface ScoreIdsInputProps {
  title: string;
  metricsClassName: string;
  placeholder?: string;
  testidPrefix?: string;
  values?: string[];
  percent?: string;
}

type FormRegister = Partial<
  ReturnType<UseFormRegister<ReconciliationFormData>>
>;

export const ScoreIdsInput = React.forwardRef<
  HTMLTextAreaElement,
  ScoreIdsInputProps & FormRegister
>(function BaseScoreIdsInput(
  {
    metricsClassName,
    title,
    values,
    percent,
    placeholder,
    testidPrefix = "score-ids",
    onChange,
    name,
  },
  ref
) {
  const formattedValues = (values || []).join("\n");

  return (
    <>
      <h5>
        {title}
        <span
          data-testid={`${testidPrefix}-metrics`}
          className={metricsClassName}
        >
           {values.length}{percent}
        </span>
      </h5>
      <textarea
        ref={ref}
        onChange={onChange}
        name={name}
        readOnly={!onChange}
        value={!onChange ? formattedValues : undefined}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck={false}
        placeholder={placeholder}
        data-testid={`${testidPrefix}-textarea`}
      />
    </>
  );
});
